<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div *ngFor="let customField of orderedCustomFieldDef$ | async">
	<!-- Component -->
	<ng-container [ngSwitch]="customField.view.type.toLowerCase()">
		<custom-field-text
			*ngSwitchCase="TypeTextLC"
			automationId="TypeTextLC"
			[customField]="customField"
			[formControl]="customFieldsListFormGroup.get(customField.$id)"
		>
		</custom-field-text>

		<custom-field-number
			*ngSwitchCase="TypeNumberLC"
			automationId="TypeNumberLC"
			[customField]="customField"
			[formControl]="customFieldsListFormGroup.get(customField.$id)"
		>
		</custom-field-number>

		<custom-field-dropdown
			*ngSwitchCase="TypeDropDownListLC"
			automationId="TypeDropDownListLC"
			[customField]="customField"
			[formControl]="customFieldsListFormGroup.get(customField.$id)"
			[required]="!!customField.view.isRequired"
		>
		</custom-field-dropdown>

		<custom-field-link
			*ngSwitchCase="TypeLinkLC"
			automationId="TypeLinkLC"
			[customField]="customField"
			[allowList]="allowList$ | async"
			[formControl]="customFieldsListFormGroup.get(customField.$id)"
			[planId]="planId"
			[ticketId]="editedTicketId"
		>
		</custom-field-link>
	</ng-container>
</div>

<ng-content></ng-content>
